<a id="whatsapp"
    href="https://api.whatsapp.com/send?phone=0986108591&text=Gracias por comunicarte con Servios! En breve te responderemos"
    target="_blank"><i class="fab fa-whatsapp"></i></a>


<app-header> </app-header>

<app-banner></app-banner>

<app-about></app-about>

<app-services></app-services>

<app-works></app-works>
<app-counter></app-counter>
<app-testimonial></app-testimonial>
<app-contacto></app-contacto>

<app-footer></app-footer>